import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ModuleService } from "../shared/module.service";
import * as _ from "lodash";
import { ToastrService } from "ngx-toastr";
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { LocalStorageService } from "../shared/local-storage.service";
import { OfferService } from "../shared/offer.service";
import * as jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

@Component({
    selector: 'app-wizard',
    templateUrl: './wizard.component.html',
    styleUrls: ['./wizard.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class WizardComponent implements OnInit {

    revertedData = null;
    FORMMODES = {
        EDIT: 1,
        READONLY: 2,
    };

    printTime = new Date();
    isLoading = false;
    isSaving = false;
    isPrinting = false;
    generatingPDF = false;
    wasBeaconQuantityAssigned = false;

    formMode = null;
    routeParams = null;
    routeAction = null;

    activeInputName = null;
    activeTab: number = 1;

    summaryCost: number = 0;
    monthlyCost: number = 0;

    modules = [];
    baseFormCopy = [];
    dataForDisplaying = null;

    museum_types = [
        {id: 1, name: "Art Museum"},
        {id: 2, name: "History/Natural"},
        {id: 3, name: "History/Science Museum"},
        {id: 4, name: "Historical Ship"},
        {id: 5, name: "Zoo/Gardens"},
        {id: 6, name: "Aquarium"},
        {id: 7, name: "School/University"},
        {id: 8, name: "Religious Site"},
        {id: 9, name: "Sporting Arena"},
        {id: 10, name: "Other"}
    ];

    experience_types = [
        {id: 1, name: "Indoor"},
        {id: 2, name: "Outside"},
        {id: 3, name: "Both"}
    ];

    tabs = [
        {id: 1, name: 'Intro'},
    ];

    generalData = null;

    configs = ['base_config', 'managed_config', 'creation_config'];

    /***
     * Create fields for forms on intro & contact tab
     */
    introPageForm: FormGroup;
    square_footage: FormControl = new FormControl('', [Validators.required, Validators.min(1)]);
    yearly_visitors: FormControl = new FormControl('', [Validators.required, Validators.min(1)]);
    museum_type: FormControl = new FormControl('', [Validators.required]);
    experience_type: FormControl = new FormControl('', [Validators.required]);

    contactPageForm: FormGroup;
    name: FormControl = new FormControl('', [Validators.required]);
    email: FormControl = new FormControl('', [Validators.required, Validators.email]);
    phone: FormControl = new FormControl('', [Validators.required]);
    message: FormControl = new FormControl('', []);

    emails: any = [];

    constructor(private moduleService: ModuleService,
                private toastr: ToastrService,
                private route: ActivatedRoute,
                private router: Router,
                private localStorage: LocalStorageService,
                private offerService: OfferService,
                private formBuilder: FormBuilder) {
        /**
         * Create form with prepared form fields
         */
        this.introPageForm = new FormGroup({
            square_footage: this.square_footage,
            yearly_visitors: this.yearly_visitors,
            museum_type: this.museum_type,
            experience_type: this.experience_type
        });

        this.introPageForm.controls['museum_type'].setValue(undefined);
        this.introPageForm.controls['experience_type'].setValue(undefined);

        this.contactPageForm = new FormGroup({
            name: this.name,
            email: this.email,
            phone: this.phone,
            message: this.message,
            emails: this.formBuilder.array([])
        })
    }

    ngOnInit() {
        /**
         * Read route ID and action...
         */
        this.route.params.subscribe(param => this.routeParams = param);
        this.route.data.subscribe(param => this.routeAction = param);
        this.loadModules();
    }

    loadModules() {
        this.isLoading = true;
        this.moduleService.getModules()
            .then(data => {
                this.isLoading = false;
                let _formCopy = this.baseFormCopy;
                _.forEach(data['objects'], function (object) {
                    _formCopy.push(object);
                });

                /**
                 * Do we have id on URL...?
                 * And does it valid...?
                 */
                if (this.routeParams && this.routeParams.hasOwnProperty('id')) {
                    this.isLoading = true;
                    this.offerService.getOffer(this.routeParams.id)
                        .then(revert => {
                            this.formMode = this.FORMMODES.EDIT;
                            this.revertedData = revert['config'];
                            this.printTime = revert['created'];

                            if (this.routeAction && this.routeAction.action === 'edit') {
                                this.fillBaseForms(revert);
                                this.checkChanges(data['objects']);
                                this.prepareFormForDisplay(data['objects']);
                                this.updateCost();
                            } else {
                                this.formMode = this.FORMMODES.READONLY;
                                this.activeTab = -1;
                                this.generalData = {
                                    introPageForm: revert['intro'],
                                    contactPageForm: revert['contact']
                                };

                                this.generalData.introPageForm.museum_type = _.find(this.museum_types, {id: this.generalData.introPageForm.museum_type}).name;
                                this.generalData.introPageForm.experience_type = _.find(this.experience_types, {id: this.generalData.introPageForm.experience_type}).name;
                                this.calculateCosts(this.revertedData);
                                this.prepareFormForDisplay(this.revertedData);
                            }
                            this.isLoading = false;
                        })
                        .catch(error => {
                            this.isLoading = false;
                            this.toastr.error('Wrong form ID! New form has been opened.', 'Error', {timeOut: 5000});
                            this.router.navigate(['/']);
                        });
                } else {
                    this.formMode = this.FORMMODES.EDIT;
                    this.dataForDisplaying = data['objects'];
                    this.loadDataFromLocalStorage(this.dataForDisplaying);
                }
            }).catch(data => {
            this.isLoading = false;
        });
    }

    prepareFormForDisplay(formData) {
        /***
         * Assign childrens for proper parent element
         */
        let childrens = _.remove(formData, function (o) {
            return o['parent_id'];
        });

        _.forEach(childrens, function (child) {
            let parent = _.find(formData, function (object) {
                return object.id === child['parent_id'];
            });

            if (parent) {
                if (!parent.childrens) {
                    parent.childrens = [];
                }
                parent.childrens.push(child);
            }
        });

        /***
         * Divide elements and create array of sections...
         */
        this.modules = _.chain(formData)
            .groupBy(function (module) {
                return module.section;
            })
            .map(function (v, k) {
                return {key: _.startCase(k), values: v}
            }).value();

        this.modules.forEach(module => {
            this.tabs.push({id: this.tabs.length + 1, name: module.key});
        });

        [{id: 3, name: 'Contact Information'},
            {id: 4, name: 'Confirmation'}].forEach(tab => {
            this.tabs.push(tab);
        });
    }

    /**
     * Loading data from localstorage...
     */
    loadDataFromLocalStorage(formData) {
        let _configs = this.configs;
        if (this.localStorage.isSaved()) {
            let cached = this.localStorage.loadData();
            this.fillBaseForms(cached);
            _.forEach(formData, function (o) {
                _.forEach(_configs, function (config) {
                    let module = _.find(cached.config, function (storage) {
                        return o.code === storage.code;
                    });

                    if (module) {
                        if (o.hasOwnProperty(config) && module.hasOwnProperty(config)) {
                            o[config].unit_quantity = module[config].unit_quantity
                        }
                    }
                });
            });
            this.calculateCosts(formData);

            this.toastr.success('Data has been loaded!',
                'Success',
                {timeOut: 5000});
        }
    }

    /**
     * Fill forms on intro & contact page
     */
    fillBaseForms(data) {
        let emails = _.cloneDeep(data.contact.emails);
        delete data.contact.emails;

        _.forEach(data.intro, (value, key) => {
            if (value)
                this.introPageForm.controls[key].setValue(value);
        });

        _.forEach(data.contact, (value, key) => {
            if (value)
                this.contactPageForm.controls[key].setValue(value);
        });

        _.forEach(emails, (address) => {
            this.addEmail(address)
        });
    }

    /**
     * Functions which deals with tab changing (and validation data)
     */
    goToNextStep() {
        this.validateStep();
    }

    goToStep(step) {
        if (step) {
            if (step === 7) {
                this.markFieldsAsTouched(this.introPageForm);
                this.markFieldsAsTouched(this.contactPageForm);

                if (this.introPageForm.invalid || this.contactPageForm.invalid) {
                    this.toastr.error('You have to fill forms on Intro and Contact Tab!', 'Forms Error', {timeOut: 5000});
                }
                return;
            }

            if (step < this.activeTab) {
                this.activeTab = step;
            } else {
                this.validateStep(step);
            }
        }
    }

    /**
     * Mark fields as touched to call "validation"
     */
    markFieldsAsTouched(form) {
        _.forEach(form.controls, (control) => {
            if (control.hasOwnProperty('controls')) {
                _.forEach(control.controls, (_control, _key) => {
                    this.markFieldsAsTouched(control.controls[_key]);
                });
            } else {
                control.markAsTouched();
            }
        });
    }

    validateStep(next_step?) {
        if (this.activeTab === 1) {
            this.markFieldsAsTouched(this.introPageForm);

            if (this.introPageForm.valid) {

                /**
                 * Check that only on first tab changing!
                 */
                if (!this.wasBeaconQuantityAssigned && !this.revertedData) {
                    let area = this.introPageForm.value.square_footage;
                    let module = _.find(this.dataForDisplaying, {'code': 'beacon-calibration'});
                    module['base_config'].unit_quantity = area % 215 === 0 ? area / 215 : Math.floor(area / 215) + 1
                    this.prepareFormForDisplay(this.dataForDisplaying);
                    this.updateCost();
                    this.wasBeaconQuantityAssigned = true;
                }

                this.activeTab = next_step || this.activeTab + 1;
                return;
            }
        }

        if (this.activeTab >= 2 && this.activeTab <= (2 + this.modules.length - 1)) {
            this.activeTab = next_step || this.activeTab + 1;
            return;
        }

        if (this.activeTab === this.modules.length - 1 + 3) {

            this.markFieldsAsTouched(this.contactPageForm);

            if (this.contactPageForm.valid && this.introPageForm.valid) {
                this.saveForm(this.prepareDataForSaving());
                return;
            }
        }

        this.toastr.error('You must properly complete a form!',
            'Invalid form data!',
            {timeOut: 5000})
    }

    goToPreviousStep() {
        this.goToStep(this.activeTab - 1)
    }

    setActiveInput(name) {
        this.activeInputName = name || null;
    }

    /**
     * Calculate cost of selected modules
     */
    calculateCosts(data) {
        let new_summary_cost = 0;
        let new_monthly_cost = 0;
        let configs = this.configs;

        _.forEach(data, function (object) {
            let module_summary_cost = 0;
            let module_monthly_cost = 0;

            if (object.parent_id) {
                let asd = _.find(data, function (element) {
                    return element.id === object.parent_id
                });
                if (asd.base_config && !asd.base_config.unit_quantity)
                    return;
            }

            _.forEach(configs, function (type) {
                if (object.hasOwnProperty(type) && object['status'] !== 'removed' && object['base_config'].unit_quantity) {
                    if (object[type].type === 'boolean') {
                        if (object[type].unit_quantity) {
                            module_summary_cost += object[type].setup_cost;
                            module_monthly_cost += object[type].monthly_cost;
                        }
                    }

                    if (object[type].type === 'integer') {
                        if (object[type].unit_quantity) {
                            module_summary_cost += object[type].setup_cost + object[type].unit_quantity * object[type].unit_cost;
                            module_monthly_cost += object[type].monthly_cost;
                        }
                    }
                }
            });

            new_summary_cost += module_summary_cost;
            new_monthly_cost += module_monthly_cost;
        });

        this.summaryCost = new_summary_cost;
        this.monthlyCost = new_monthly_cost;
    }

    /**
     * Update calculated cost after any of form data changes
     */
    updateCost() {
        this.calculateCosts(this.baseFormCopy);
    }

    /**
     * Add additional email address
     */
    addEmail(data?) {
        this.emails = this.contactPageForm.get('emails') as FormArray;
        this.emails.push(
            this.formBuilder.group({
                'address': new FormControl(data || '', Validators.email),
            }));
    }

    /**
     * Remove additional email address
     */
    removeEmail(i) {
        this.emails = this.contactPageForm.get('emails') as FormArray;
        this.emails.removeAt(i)
    }

    /**
     * Preparing data for saving
     * (remove unnecessary "children" key and unavailable modules)
     */
    prepareDataForSaving() {
        let form = _.cloneDeep(this.baseFormCopy);

        _.remove(form, function (obj) {
            return obj.status === 'removed'
        });

        _.forEach(form, function (obj) {
            if (obj.childrens) {
                delete obj.childrens;
            }
        });
        let data = {
            intro: _.cloneDeep(this.introPageForm.value),
            contact: _.cloneDeep(this.contactPageForm.value),
            monthly_cost: _.cloneDeep(this.monthlyCost),
            setup_cost: _.cloneDeep(this.summaryCost),
            config: form
        };

        if (data.contact.emails.length)
            data.contact.emails = data.contact.emails.map(x => x.address);

        return data
    }

    /**
     * Check what was changed between
     * current initial form and previous saved form
     */
    checkChanges(data) {
        let showToast = false;
        let formCopy = data;
        let configs = this.configs;

        _.forEach(this.revertedData, function (reverted) {
            module = _.find(formCopy, function (object) {
                return object.code === reverted.code
            });

            if (module) {
                if (_.isEqual(reverted, module)) {
                    module['status'] = 'ok';
                } else {
                    module['status'] = 'changed';

                    /* Rewrite unit quantity to the "new" form... */
                    _.forEach(configs, function (config) {
                        if (module[config] && reverted[config]) {
                            module[config].unit_quantity = reverted[config].unit_quantity;
                        }
                    });
                    showToast = true;
                }
            } else {
                reverted['status'] = 'removed';
                formCopy.push(reverted);
                showToast = true;
            }
        });

        if (showToast) {
            this.toastr.warning('We have changed a price and/or added or removed features since you last visited the configuration tool. Please review the options again before submitting the form.',
                'Form data changed!',
                {timeOut: 0})
        }

        return formCopy;
    }

    saveToLocalStorage() {
        this.localStorage.saveData(this.prepareDataForSaving());
        this.toastr.success('Data has been saved!', 'Success');
    }

    saveForm(data) {
        this.isSaving = true;
        this.offerService.saveOffer(data)
            .then(data => {
                this.toastr.success('Offer has been created!', 'Success');
                this.activeTab = 7;
                this.localStorage.clear();
                this.isSaving = false;
            })
            .catch(errors => {
                this.toastr.error(errors && errors.message ? errors.message : 'Something goes wrong. Please, try again later.', 'Error');
                this.isSaving = false;
            })
    }

    /**
     * Generating PDF from website content
     * (and divide it into pages)...
     */
    generatePDF() {
        this.isPrinting = true;
        this.generatingPDF = true;

        setTimeout(() => {
            html2canvas(document.querySelector("#wizard-page"), {
                windowWidth: 1200,
                x: 0
            }).then(canvas => {
                this.isPrinting = false;

                var image = new Image();
                image.src = canvas.toDataURL('image/jpeg');
                setTimeout(() => {
                    var doc = new jsPDF('p', 'mm', 'a4');
                    var croppingYPosition = 0;
                    var count = (canvas.height) / 1625;
                    for (var i = 0; i < count; i++) {
                        if (i > 0)
                            doc.addPage();
                        var sourceX = 0;
                        var sourceY = croppingYPosition;
                        var sourceWidth = canvas.width;
                        var sourceHeight = canvas.height - croppingYPosition >= 1625 ? 1625 : canvas.height - croppingYPosition;
                        var destWidth = sourceWidth;
                        var destHeight = sourceHeight;
                        var destX = 0;
                        var destY = 0;
                        var canvas1 = document.createElement('canvas');
                        canvas1.setAttribute('height', destHeight + '');
                        canvas1.setAttribute('width', destWidth + '');
                        var ctx = canvas1.getContext("2d");
                        ctx.imageSmoothingEnabled = true;
                        ctx.drawImage(image, sourceX,
                            sourceY,
                            sourceWidth,
                            sourceHeight,
                            destX,
                            destY,
                            destWidth,
                            destHeight);
                        var image2 = new Image();
                        image2.src = canvas1.toDataURL('image/jpeg');

                        var size_height = canvas.height - croppingYPosition >= 1625 ? 285 : (285 * (canvas.height - croppingYPosition)) / 1650;
                        doc.addImage(image2, 'JPEG', 5, 5, 200, size_height);
                        croppingYPosition += destHeight;
                    }
                    doc.save('Guru_App_Configuration_' + this.routeParams.id + '.pdf');
                    this.generatingPDF = false;
                });
            });
        })
    }
}



// WEBPACK FOOTER //
// /Users/dominik/Documents/projekty/guru-apps-saas/src/app/wizard/wizard.component.ts